import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Formik } from 'formik';
import { useCallback, useImperativeHandle, useRef, memo, forwardRef, useMemo, } from 'react';
import { usePreferences } from '../../context/PreferencesContext';
import Label from '../../elements/Label';
import FormikColorInput from '../../elements/formik/FormikColorInput';
import { formatFieldLabelStyle } from '../../elements/formik/FormikColumnFormatField';
import FormikNumberInput from '../../elements/formik/FormikNumberInput';
import useNucleus from '../../hooks/useNucleus';
import { usePanelPreferencesByNuclei } from '../../hooks/usePanelPreferences';
import { getUniqueNuclei } from '../../utility/getUniqueNuclei';
import { NucleusPreferences, } from '../extra/preferences/NucleusPreferences';
import { PreferencesContainer } from '../extra/preferences/PreferencesContainer';
const formatFields = [
    {
        id: 1,
        label: 'Absolute :',
        checkControllerName: 'absolute.show',
        formatControllerName: 'absolute.format',
    },
    {
        id: 2,
        label: 'Relative :',
        checkControllerName: 'relative.show',
        formatControllerName: 'relative.format',
    },
    {
        id: 3,
        label: 'Kind :',
        checkControllerName: 'showKind',
        hideFormatField: true,
    },
];
function IntegralsPreferences(props, ref) {
    const preferences = usePreferences();
    const nucleus = useNucleus();
    const nuclei = useMemo(() => getUniqueNuclei(nucleus), [nucleus]);
    const preferencesByNuclei = usePanelPreferencesByNuclei('integrals', nuclei);
    const formRef = useRef();
    const saveHandler = useCallback((values) => {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'integrals', value: values },
        });
    }, [preferences]);
    useImperativeHandle(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }));
    return (_jsx(PreferencesContainer, { children: _jsx(Formik, { initialValues: preferencesByNuclei, onSubmit: saveHandler, innerRef: formRef, children: _jsx(_Fragment, { children: nuclei?.map((n) => (_jsx(NucleusPreferences, { nucleus: n, fields: formatFields, renderTop: () => (_jsxs(_Fragment, { children: [_jsx(Label, { title: "Color", style: formatFieldLabelStyle, children: _jsxs("div", { style: { display: 'flex', padding: '2px 0' }, children: [_jsx("div", { style: { width: '23px' } }), _jsx(FormikColorInput, { name: `nuclei.${n}.color` })] }) }), _jsx(Label, { title: "stroke width :", style: formatFieldLabelStyle, children: _jsxs("div", { style: { display: 'flex', padding: '2px 0' }, children: [_jsx("div", { style: { width: '23px' } }), _jsx(FormikNumberInput, { name: `nuclei.${n}.strokeWidth`, style: {
                                                width: '60%',
                                                textAlign: 'center',
                                                padding: '2px',
                                            }, min: 1, max: 9, pattern: "[1-9]+" })] }) })] })) }, n))) }) }) }));
}
export default memo(forwardRef(IntegralsPreferences));
